<script setup>
import { __ } from '@/utils';
import { formFragmentValues } from "@/utils";
import { inject } from 'vue';
import Loader from '@components/loader.vue';

const { progressUpdate } = inject('step');

const localValues = formFragmentValues();
const submitButtonText = localValues.activeStep !== localValues.lastStep ? __('Completion of an order') : __('For Payment');
</script>
<template>
	<div class="form__actions">
		<button type="submit" class="btn btn--arrows" v-if="!progressUpdate">
			<template v-if="localValues.activeStep < 3 || !localValues.activeStep">
				{{ __('Continued')}}
			</template>
			<template v-else>
				{{ submitButtonText }}
			</template>
		</button><!-- /.btn btn--has-arrows form__btn -->

		<Loader color="#2563eb" v-if="progressUpdate"/>
	</div><!-- /.form__actions -->
</template>
